import { getCurrentJWTUser, logout } from '../lib/auth';

export const useAuth = () => {
  const user = getCurrentJWTUser();
  const isAuthenticated = !!user;

  return { user, isAuthenticated, logout: logout };
};
